
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { getTagsList, addTags, editorTags, delTags } from '../../api/tags';

@Component({
  name: 'SettingTemplateTags',
  components: {

  }
})
export default class extends Vue {
  private tableData = []
  private addOneTagsVisible = false
  private formTags:any= {
    id: '',
    name: '',
    instructions_prompt: ''
  }
  private addSubTagsVisible = false
  private formSubTags: any = {
    first: '',
    firstText: '',
    second: '',
    warningTxt: false,
    remark: '',
    brief: '',
    describe: ''
  }
  created() {
    this.getTagsList();
  }

  private addOneHandle() {
    this.formTags = {};
    this.addOneTagsVisible = true;
  }
  private editOneHandle(row:any) {
    this.addOneTagsVisible = true;
    this.formTags.id = row.tags_id;
    this.formTags.name = row.tags_name;
    this.formTags.instructions_prompt = row.instructions_prompt;
  }
  private delOneHandle(row:any) {
    this.$confirm('是否删除?', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.delTags(row.tags_id);
      })
      .catch(() => {});
  }
  private oneDialogHandle() {
    if (!this.formTags.name) {
      this.showErrorMsg('请输入一级标签');
      return;
    }
    if (this.formTags.name.length < 1 || this.formTags.name.length > 8) {
      this.showErrorMsg('请输入1-8位一级标签');
      return;
    }
    if (this.formTags.id) {
      this.addTags(this.formTags.id, '', this.formTags.name, this.formTags.instructions_prompt, '', '', '', '');
    } else {
      this.addTags('', '', this.formTags.name, this.formTags.instructions_prompt, '', '', '', '');
    }
  }

  private editSubHandle(row:any) {
    this.formSubTags = {
      first: row.pname,
      firstText: row.p_instructions_prompt,
      firstId: row.pid,
      second: row.tags_name,
      warningTxt: parseInt(row.modify_prompt_state) === 1,
      remark: row.deal_remark_prompt,
      brief: row.repair_summary_prompt,
      describe: row.trouble_describle_prompt,
      id: row.tags_id
    };
    this.addSubTagsVisible = true;
  }
  private addSubTagsHandle(row:any) {
    this.formSubTags = {
      first: row.tags_name,
      firstText: row.instructions_prompt,
      firstId: row.tags_id,
      second: '',
      warningTxt: false,
      remark: '',
      brief: '',
      describe: '',
      id: ''
    };
    this.addSubTagsVisible = true;
  }
  private delSubTagsHandle(row:any) {
    this.$confirm('是否删除?', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.delTags(row.tags_id);
      })
      .catch(() => {});
  }
  private subDialogHandle() {
    if (!this.formSubTags.second) {
      this.showErrorMsg('请输入二级标签');
      return;
    }
    if (this.formSubTags.second.length < 1 || this.formSubTags.second.length > 8) {
      this.showErrorMsg('请输入1-8位二级标签');
      return;
    }
    this.addSubTagsVisible = false;
    if (this.formSubTags.id) {
      this.addTags(this.formSubTags.id, this.formSubTags.firstId, this.formSubTags.second, this.formSubTags.firstText, this.formSubTags.warningTxt ? 1 : 0, this.formSubTags.remark, this.formSubTags.brief, this.formSubTags.describe);
    } else {
      this.addTags('', this.formSubTags.firstId, this.formSubTags.second, this.formSubTags.firstText, this.formSubTags.warningTxt ? 1 : 0, this.formSubTags.remark, this.formSubTags.brief, this.formSubTags.describe);
    }
  }
  private getTagsList() {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    getTagsList(params).then(res => {
      if (res.data) {
        this.tableData = res.data.list;
      } else {
        this.tableData = [];
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private addTags(tagsId:any, pid:any, name: any, instructionsPrompt: any, modifyPromptState: any, dealRemarkPrompt: any, repairSummaryPrompt: any, troubleDescriblePrompt: any) {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    if (name) {
      params.name = name;
    }
    params.instructions_prompt = instructionsPrompt;
    if (modifyPromptState) {
      params.modify_prompt_state = modifyPromptState;
    }
    if (dealRemarkPrompt) {
      params.deal_remark_prompt = dealRemarkPrompt;
    }
    if (repairSummaryPrompt) {
      params.repair_summary_prompt = repairSummaryPrompt;
    }
    if (troubleDescriblePrompt) {
      params.trouble_describle_prompt = troubleDescriblePrompt;
    }
    if (pid) {
      params.pid = pid;
    }
    if (tagsId) {
      params.tags_id = tagsId;
      editorTags(params).then(res => {
        this.showSuccessMsg((res as any).msg);
        this.getTagsList();
        this.addOneTagsVisible = false;
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    } else {
      addTags(params).then(res => {
        this.showSuccessMsg((res as any).msg);
        this.getTagsList();
        this.addOneTagsVisible = false;
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
  }
  private delTags(tagsId:any) {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    params.tags_id = tagsId;
    delTags(params).then(res => {
      this.showSuccessMsg((res as any).msg);
      this.getTagsList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
